import { Grid } from "@mui/material";
import MxFormDescriptionTitle from "./MxFormDescriptionTitle";
import MxFormSubTitle from "./MxFormSubTitle";
import { ResponsiveStyleValue } from "@mui/system";

interface MxFormSubTitleAndDescriptionProps {
  label: string;
  description: string;
  isRequired?: boolean;
  color?: ResponsiveStyleValue<string | readonly string[] | undefined>;
}
const MxFormSubTitleAndDescription = (props: MxFormSubTitleAndDescriptionProps) => {
  return (
    <Grid container item xs={12} spacing={0.4} gap={0.5}>
      <Grid item xs={12}>
        <MxFormSubTitle label={props.label} isRequired={props.isRequired} />
      </Grid>
      <Grid item xs={12}>
        <MxFormDescriptionTitle label={props.description} color={props.color} />
      </Grid>
    </Grid>
  );
};

export default MxFormSubTitleAndDescription;
